import type { ShellSkin } from '../types';
import { WorkspaceShell } from './WorkspaceShell';
import { DesktopShell } from './DesktopShell';
import { ClassicShell } from './ClassicShell';

// The skin registry. Order here is the order they appear in the switcher. `workspace` is the
// default (see ShellProvider.DEFAULT_SKIN). To add a skin: build a ShellSkin.Component and
// list it here — nothing else needs to change.

export const SKINS: ShellSkin[] = [
  {
    id: 'workspace',
    label: 'Workspace',
    description: 'Area rail + focused sidebar and record tabs',
    icon: 'layout-dashboard',
    Component: WorkspaceShell,
  },
  {
    id: 'desktop',
    label: 'Desktop',
    description: 'Menu bar and draggable windows',
    icon: 'monitor',
    Component: DesktopShell,
  },
  {
    id: 'classic',
    label: 'Classic',
    description: 'The single full-height sidebar',
    icon: 'panel-left',
    Component: ClassicShell,
  },
];

export { WorkspaceShell } from './WorkspaceShell';
export { DesktopShell } from './DesktopShell';
export { ClassicShell } from './ClassicShell';
